import {
  GridLoadMore,
  useGrid,
} from "@aleksundshantu/aunds-utils-react/primitives/grid";
import buttonStyles from "../../components/Button/Button.module.scss";
import styles from "./GridPagination.module.scss";
import { useGlobalContext } from "@aleksundshantu/aunds-utils-react/contexts";
import { CustomSVG } from "@/components/_primitives/CustomSVG/CustomSVG.tsx";
import React from "react";
import { useRouter } from "next/router";

type GridPaginationProps = {
  className?: string;
};

export const GridPagination = ({ className }: GridPaginationProps) => {
  const { currentPage, setCurrentPage, postsTotal, postsPerPage } = useGrid();
  const { getIcon } = useGlobalContext();
  const { query, push } = useRouter();

  const amountPages = Math.ceil(postsTotal / postsPerPage);

  if (amountPages <= 1) return null;

  const navigateToPage = (page: number) => {
    setCurrentPage(page);

    const dynamicRoute = query["dynamicRoute"]
      ? (query["dynamicRoute"] as string[])
      : [];
    const path = dynamicRoute.join("/");
    const letter = query["letter"] ?? null;
    const date = query["date"] ?? null;
    const keyword = query["keyword"] ?? null;

    push(
      `${path}?pt=grid&page=${page}${letter ? `&letter=${letter}` : ""}${date ? `&date=${date}` : ""}${keyword ? `&keyword=${keyword}` : ""}`,
      `${path}/?page=${page}&pt=grid${letter ? `&letter=${letter}` : ""}${date ? `&date=${date}` : ""}${keyword ? `&keyword=${keyword}` : ""}`,
      { shallow: true, scroll: false },
    );
  };

  return (
    <div className={`${styles["grid-pagination-wrapper"]} ${className}`}>
      <GridLoadMore
        grid_navigation="only-pagination"
        buttonStyles={buttonStyles}
      />

      <div className={styles["grid-navigation"]}>
        <button
          type="button"
          onClick={() => navigateToPage(currentPage - 1)}
          disabled={currentPage <= 1}
        >
          <CustomSVG
            width={14}
            height={14}
            src={getIcon("arrowLeftGrid")}
            wrapper={"span"}
            aria-hidden="true"
            className="is-flex"
          />
        </button>

        <button
          type="button"
          onClick={() => navigateToPage(currentPage + 1)}
          disabled={currentPage >= amountPages}
        >
          <CustomSVG
            height={14}
            width={14}
            src={getIcon("arrowRightGrid")}
            wrapper={"span"}
            className="is-flex"
            aria-hidden="true"
          />
        </button>
      </div>
    </div>
  );
};
